import { businessKey } from 'queryKeys';

export const AFFILIATES = 'AFFILIATES';

const MUTATION_TOTEST = 'totest';
const MUTATION_QA = 'qa';
const MUTATION_EXPORT = 'export';
const MUTATION_COMMENT = 'comment';

const afQuery = businessKey.query(AFFILIATES);

export const grids = afQuery.grids();
export const grid = afQuery.grid();
export const model = afQuery.exact();
export const details = afQuery.details();

export const mutations = afQuery.mutations();

export const create = mutations.create();
export const update = mutations.update();
export const archive = mutations.archive();
export const restore = mutations.restore();

export const totest = mutations.mutate(MUTATION_TOTEST);
export const comment = mutations.mutate(MUTATION_COMMENT);
export const qa = mutations.mutate(MUTATION_QA);
export const exportAffs = mutations.mutate(MUTATION_EXPORT);
